import React, { useContext, useRef, useState } from 'react';
import { Dropdown, OverlayTrigger, Tooltip, Button } from 'react-bootstrap';
import { withTranslation, useTranslation } from 'react-i18next';
import { BiDotsHorizontalRounded } from 'react-icons/bi';
import { FaChevronDown, FaChevronRight, FaPlus } from 'react-icons/fa';
import { SidebarContext } from '../../../App';
import ConfirmationModal from '../../../components/ConfirmationModal/ConfirmationModal';
import { ReportSection } from '../../../core/constants/common';
import { getTranslation } from '../../../core/utilities/TranslationHelpers';
import './Reporting.scss';
const ESRSReportingSidebar = ({
  t,
  sections,
  activeSectionIndex,
  activePageIndex,
  language,
  onPageChange,
  onAddingNewSection,
  onAddingNewPage,
  onDeletingSection,
  onDeletingPage,
  onUpdatingSection,
  onUpdatingPage,
  onContentEdited,
  onReorderPage,
  onAddingNewPageFromSuggestion
}) => {
  const { i18n } = useTranslation();
  const [showNewSectionEditor, setShowNewSectionEditor] = useState(false);
  const inputRef = useRef([]);
  const [editedSections, setEditedSections] = useState({});
  const [editedPages, setEditedPages] = useState({});
  const [renderedOn, setRenderedOn] = useState(0);
  const [draggedPage, setDraggedPage] = useState({ pageId: null, sectionId: null });
  const [draggedOver, setDraggedOver] = useState({ pageId: null, sectionId: null });
  const { sidebarDisplay, setSidebarDisplay } = useContext(SidebarContext);
  const [hiddenSection, setHiddenSection] = useState({});
  const [itemToDelete, setItemToDelete] = useState({ forSection: false, section: null, page: null });


  const onPageDragStart = (e, page, section) => {
    setDraggedPage({ pageId: page.index, sectionId: section.index });
  };

  const onPageDragEnd = (e, page) => {
    onReorderPage({
      page: draggedPage,
      over: draggedOver
    });
    setDraggedOver({});
    setDraggedPage({});
  };

  const onDragOver = (e, page, section) => {
    setDraggedOver({ pageId: page.index, sectionId: section.index });
  };
  const saveChangesConfirmationCallBack = (val) => {
    if (!val) {
      setItemToDelete({ section: null, page: null });
      return;
    }
    {
      if (itemToDelete.forSection) {
        onDeletingSection(itemToDelete.section.index);
      } else {
        onDeletingPage(itemToDelete.section.index, itemToDelete.page.index);
      }
      setItemToDelete({ forSection: false, section: null, page: null });
      onContentEdited(false);
    }
  }
  const getEditTextField = ({ forSection, section, page, value }) => {
    let inputId;
    if (forSection) {
      inputId = `sectionInput-${section.index}`;
    } else {
      inputId = `pageInput-${section.index}-${page.index}`;
    }
    return (<div>
      <div>
        <input type="text"
          id={inputId}
          className="form-control"
          maxLength={100}
          ref={ref => inputRef.current[inputId] = ref}
          defaultValue={value} />
      </div>
      <div className='mt-2'>
        <Button variant="primary"
          className='me-2'
          onClick={() => {
            // if (forSection) {
            //   onUpdatingSection(section.index, inputRef.current[inputId].value);
            //   editedSections[`section-${section.index}`] = false;
            //   setEditedSections(editedSections);
            // } else {
            //   onUpdatingPage(section.index, page.index, inputRef.current[inputId].value);
            //   editedPages[`page-${section.index}-${page.index}`] = false;
            //   setEditedPages(editedPages);
            // }
            if (forSection) {
              onUpdatingSection(section.index, inputRef.current[inputId].value);            
              setEditedSections(prev => ({
                ...prev,
                [`section-${section.index}`]: false,
              }));
              
            } else {
              onUpdatingPage(section.index, page.index, inputRef.current[inputId].value);            
              setEditedPages(prev => ({
                ...prev,
                [`page-${section.index}-${page.index}`]: false,
              }));
            }
            
            setRenderedOn(Date.now());
          }}>
          {t("Save.label")}
        </Button>
        <Button
          variant='secondary'
          className='me-2'
          onClick={() => {
            // if (forSection) {
            //   editedSections[`section-${section.index}`] = false;
            //   setEditedSections(editedSections);
            // } else {
            //   editedPages[`page-${section.index}-${page.index}`] = false;
            //   setEditedPages(editedPages);
            // }
            if (forSection) {
              setEditedSections(prev => ({
                ...prev,
                [`section-${section.index}`]: false,
              }));
            } else {
              setEditedPages(prev => ({
                ...prev,
                [`page-${section.index}-${page.index}`]: false,
              }));
            }
            setRenderedOn(Date.now());
            onContentEdited(false);
          }}>
          {t("Cancel.label")}
        </Button>
      </div>
    </div>);
  };

  const getMoreOptions = ({ forSection, section, page }) => {
    let dropId;
    if (forSection) {
      dropId = `moreDropdown-${section.index}`;
    } else {
      dropId = `moreDropdown-${section.index}-${page.index}`;
    }
    return (
      <Dropdown>
        <Dropdown.Toggle
          variant="blank_outline"
          id={dropId}>
          <BiDotsHorizontalRounded />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item onClick={() => {
            // if (forSection) {
            //   editedSections[`section-${section.index}`] = true;
            //   setEditedSections(editedSections);
            // } else {
            //   editedPages[`page-${section.index}-${page.index}`] = true;
            //   setEditedPages(editedPages);
            // }
            if (forSection) {
              setEditedSections(prev => ({
                ...prev,
                [`section-${section.index}`]: true,
              }));
            } else {
              setEditedPages(prev => ({
                ...prev,
                [`page-${section.index}-${page.index}`]: true,
              }));
            }
            setRenderedOn(Date.now());
            onContentEdited(true);
          }}>
            {t("Edit.label")}
          </Dropdown.Item>
          {
            forSection &&
            <Dropdown.Item onClick={() => {
              onAddingNewPage(section.index);
            }}>
              {t("NewPage.label")}
            </Dropdown.Item>
          }
          <Dropdown.Item onClick={() => {
            if (forSection) {
              setItemToDelete({ forSection: true, section, page: null });
            } else {
              setItemToDelete({ forSection: false, section, page });
            }
            setRenderedOn(Date.now());
          }}>
            {t("Delete.label")}
          </Dropdown.Item>

        </Dropdown.Menu>
      </Dropdown>
    );
  };

  const renderRootPages = (section, sIndex) => {
    return (
      <>
        {
          section.pages?.map((page, pIndex) => {
            return renderPageLink({
              sIndex: sIndex,
              pIndex: pIndex,
              section: section,
              page: page
            });
          })
        }
      </>
    );
  };

  const renderPageLink = ({ sIndex, pIndex, section, page }) => {
    return (
      <li key={`sectionPageItem-${sIndex}-${pIndex}`}>
        {
          draggedOver.pageId === page.index && draggedOver.sectionId === section.index && <PageDropSpacer />
        }
        {
          !editedPages[`page-${section.index}-${page.index}`]
            ?
            <div className='' onDragOver={(e) => onDragOver(e, page, section)}>
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="button-tooltip-2"> {getPageName(page, section)}</Tooltip>}
              >
                <span>
                  <a
                    data-tooltip-id="my-tooltip" data-tooltip-content="Hello world!"
                    className={activeSectionIndex === section.index && activePageIndex === page.index ? 'cursor active' : 'cursor'}
                    draggable={true}
                    onDragStart={(e) => onPageDragStart(e, page, section)}
                    onDragEnd={(e) => onPageDragEnd(e, page)}
                    onClick={() => onPageChange(section.index, page.index)}>
                    {getPageName(page, section)}
                  </a>
                  <span className='text-right'>
                    {getMoreOptions({ forSection: false, section: section, page: page })}
                  </span>
                </span>
              </OverlayTrigger>
            </div>
            : <>{getEditTextField({ forSection: false, section: section, page: page, value: page.name })}</>
        }
      </li>
    );
  };

  const getSectionName = (section) => {
    const reportLang = language || i18n.language;
    switch (section.type) {
      case ReportSection.EXECUTIVE_SUMMARY:
        return getTranslation(i18n, 'GHGReport.ExecutiveSummary.label', reportLang);
      case ReportSection.ABOUT_REPORT:
        return getTranslation(i18n, 'GHGReport.AboutReport.label', reportLang);
      case ReportSection.ORGANIZATIONAL_PROFILE:
        return getTranslation(i18n, 'GHGReport.OrganizationalProfileBoundaries.label', reportLang);
      case ReportSection.BASE_YEAR_METHODOLOGY:
        return getTranslation(i18n, 'GHGReport.BaseYearMethodology.label', reportLang);
      case ReportSection.GHG_EMISSIONS_INVENTORY:
        return getTranslation(i18n, 'GHGReport.GHGEmissionsInventory.label', reportLang);
      case ReportSection.ENERGY_USE_EMISSION_SOURCES:
        return getTranslation(i18n, 'GHGReport.EnergyUseEmissionSources.label', reportLang);
      case ReportSection.GHG_REDUCTION_STRATEGY:
        return getTranslation(i18n, 'GHGReport.GHGReductionStrategyPerformanceIndicators.label', reportLang);
      case ReportSection.VERIFICATION_ASSURANCE:
        return getTranslation(i18n, 'GHGReport.VerificationAssuranceDataQuality.label', reportLang);
      case ReportSection.INSIGHTS:
        return getTranslation(i18n, 'GHGReport.Insights.label', reportLang);
      case ReportSection.ANNEXURES:
        return getTranslation(i18n, 'GHGReport.Annexures.label', reportLang);
      case ReportSection.UAE_FDL_ABOUT_THE_ORGANIZATION:
        return getTranslation(i18n, 'UAEFDLReport.AboutTheOrganization.label', reportLang);
      case ReportSection.UAE_FDL_ABOUT_THE_REPORT:
        return getTranslation(i18n, 'UAEFDLReport.AboutTheReport.label', reportLang);
      case ReportSection.UAE_FDL_INVENTORY_OF_GHG_EMISSIONS:
        return getTranslation(i18n, 'UAEFDLReport.InventoryOfGHGEmissions.label', reportLang);
      case ReportSection.UAE_FDL_INFORMATION_ABOUT_EMISSIONS:
        return getTranslation(i18n, 'UAEFDLReport.InformationAboutEmissions.label', reportLang);
      case ReportSection.UAE_FDL_DECARBONIZATION_TARGETS_STRATEGY:
        return getTranslation(i18n, 'UAEFDLReport.DecarbonizationSection.label', reportLang);
      case ReportSection.UAE_FDL_VERIFICATION_COMPLIANCE:
        return getTranslation(i18n, 'UAEFDLReport.VerificationSection.label', reportLang);
      case ReportSection.UAE_FDL_INSIGHTS:
        return getTranslation(i18n, 'UAEFDLReport.Insights.label', reportLang);
      default:
        return section.name;
    }
  };

  const getPageName = (page, section) => {
    const reportLang = language || i18n.language;
    // For GHG report pages, translate based on section type and page type
    if (section.type === ReportSection.EXECUTIVE_SUMMARY) {
      return getTranslation(i18n, 'GHGReport.OverviewHighlights.label', reportLang);
    } else if (section.type === ReportSection.ABOUT_REPORT) {
      return getTranslation(i18n, 'GHGReport.ReportBasisScope.label', reportLang);
    } else if (section.type === ReportSection.ORGANIZATIONAL_PROFILE) {
      return getTranslation(i18n, 'GHGReport.OrganisationalStructureBoundaries.label', reportLang);
    } else if (section.type === ReportSection.BASE_YEAR_METHODOLOGY) {
      return getTranslation(i18n, 'GHGReport.ReportingBaseYearApproach.label', reportLang);
    } else if (section.type === ReportSection.GHG_EMISSIONS_INVENTORY) {
      return getTranslation(i18n, 'GHGReport.EmissionsAccounting.label', reportLang);
    } else if (section.type === ReportSection.ENERGY_USE_EMISSION_SOURCES) {
      return getTranslation(i18n, 'GHGReport.EnergyMixEmissionSources.label', reportLang);
    } else if (section.type === ReportSection.GHG_REDUCTION_STRATEGY) {
      return getTranslation(i18n, 'GHGReport.GHGManagementPerformance.label', reportLang);
    } else if (section.type === ReportSection.VERIFICATION_ASSURANCE) {
      return getTranslation(i18n, 'GHGReport.VerificationInventoryQuality.label', reportLang);
    } else if (section.type === ReportSection.INSIGHTS) {
      return getTranslation(i18n, 'GHGReport.Insights.label', reportLang);
    } else if (section.type === ReportSection.ANNEXURES) {
      return getTranslation(i18n, 'GHGReport.ReferencesSupportingMaterials.label', reportLang);
    } else if (section.type === ReportSection.UAE_FDL_ABOUT_THE_ORGANIZATION) {
      return getTranslation(i18n, 'UAEFDLReport.AboutTheOrganization.label', reportLang);
    } else if (section.type === ReportSection.UAE_FDL_ABOUT_THE_REPORT) {
      return getTranslation(i18n, 'UAEFDLReport.ObjectivesOfDecreeLaw.label', reportLang);
    } else if (section.type === ReportSection.UAE_FDL_INVENTORY_OF_GHG_EMISSIONS) {
      return getTranslation(i18n, 'UAEFDLReport.GHGEmissionsInventory.label', reportLang);
    } else if (section.type === ReportSection.UAE_FDL_INFORMATION_ABOUT_EMISSIONS) {
      return getTranslation(i18n, 'UAEFDLReport.InformationAboutEmissions.label', reportLang);
    } else if (section.type === ReportSection.UAE_FDL_DECARBONIZATION_TARGETS_STRATEGY) {
      return getTranslation(i18n, 'UAEFDLReport.DecarbonizationTargetsStrategy.label', reportLang);
    } else if (section.type === ReportSection.UAE_FDL_VERIFICATION_COMPLIANCE) {
      return getTranslation(i18n, 'UAEFDLReport.VerificationCompliance.label', reportLang);
    } else if (section.type === ReportSection.UAE_FDL_INSIGHTS) {
      return getTranslation(i18n, 'UAEFDLReport.Insights.label', reportLang);
    }
    return page.name;
  };

  const canRenderSection = (section) => {
    return section.type === ReportSection.OTHERS
      || section.type === ReportSection.OVERVIEW
      || section.type === ReportSection.REPORTING
      || section.type === ReportSection.LEADERSHIP
      || section.type === ReportSection.ABOUT_REPORT
      || section.type === ReportSection.ABOUT_COMPANY
      || section.type === ReportSection.ESG_APPROACH
      || section.type === ReportSection.ENVIRONMENT
      || section.type === ReportSection.SOCIAL
      || section.type === ReportSection.GOVERNANCE
      || section.type === ReportSection.ESG_INDEX
      || section.type === ReportSection.ROOT
      || section.type === ReportSection.GENERAL_DISCLOSURE
      || section.type === ReportSection.GENERAL_INFO
      || section.type === ReportSection.EXECUTIVE_SUMMARY
      || section.type === ReportSection.ORGANIZATIONAL_PROFILE
      || section.type === ReportSection.BASE_YEAR_METHODOLOGY
      || section.type === ReportSection.GHG_EMISSIONS_INVENTORY
      || section.type === ReportSection.ENERGY_USE_EMISSION_SOURCES
      || section.type === ReportSection.GHG_REDUCTION_STRATEGY
      || section.type === ReportSection.VERIFICATION_ASSURANCE
      || section.type === ReportSection.INSIGHTS
      || section.type === ReportSection.ANNEXURES
      || section.type === ReportSection.UAE_FDL_ABOUT_THE_ORGANIZATION
      || section.type === ReportSection.UAE_FDL_ABOUT_THE_REPORT
      || section.type === ReportSection.UAE_FDL_INVENTORY_OF_GHG_EMISSIONS
      || section.type === ReportSection.UAE_FDL_INFORMATION_ABOUT_EMISSIONS
      || section.type === ReportSection.UAE_FDL_DECARBONIZATION_TARGETS_STRATEGY
      || section.type === ReportSection.UAE_FDL_VERIFICATION_COMPLIANCE
      || section.type === ReportSection.UAE_FDL_INSIGHTS;
  };

  const renderExpandOrCollapseIcon = (s) => {
    return (
      <span className='cursor action-icon' onClick={() => {
        const d = JSON.parse(JSON.stringify(hiddenSection));
        d[s.index] = d[s.index] ? !d[s.index] : true;
        setHiddenSection(d);
      }}>
        {hiddenSection[s.index] === true ? <FaChevronRight /> : <FaChevronDown />}
      </span>
    );
  };

  return (
    <div className={`Reporting_SiderBar ${sidebarDisplay ? '' : 'left-44'}`}>
      <ul className='Reporting_siderBar_ul'>
        <li className='Reporting_SiderBar_title'>
          <a
            className={activeSectionIndex === 0 ? 'cursor active' : 'cursor'}
            onClick={() => onPageChange(0, 0)}><strong>{getTranslation(i18n, "Title.label", language || i18n.language)}</strong></a>
        </li>
        <li className='Reporting_SiderBar_Contents 2'>
          <a
            className={activeSectionIndex === 1 ? 'cursor active' : 'cursor'}
            onClick={() => onPageChange(1, 0)}><strong>{getTranslation(i18n, "Contents.label", language || i18n.language)}</strong></a>
        </li>

        {
          sections?.filter(section => canRenderSection(section))
            ?.map((section, sIndex) => {
              if (section.type === ReportSection.ROOT) {
                return renderRootPages(section, sIndex);
              } else {
                return (
                  <li key={`otherSectionItem-${sIndex}`}>
                    {
                      !editedSections[`section-${section.index}`]
                        ?
                        <span>
                          {renderExpandOrCollapseIcon(section)}
                          <a className='cursor'><b>{getSectionName(section)}</b></a>
                          <span className='text-right'>
                            {getMoreOptions({ forSection: true, section: section })}
                          </span>
                        </span>

                        : <>{getEditTextField({ forSection: true, section: section, value: section.name })}</>
                    }
                    {
                      hiddenSection[section.index] !== true &&
                      <ul>
                        {
                          section.pages?.map((page, pIndex) => {
                            return renderPageLink({
                              sIndex: sIndex,
                              pIndex: pIndex,
                              section: section,
                              page: page
                            });
                          })
                        }
                      </ul>
                    }
                  </li>
                );
              }
            })
        }

      </ul>
      <div className='Reporting_siderBar_btnBox'>
        {
          !showNewSectionEditor &&
          <div className='Reporting_siderBar_NewSectionBox'>
            <Button
              variant='primary'
              onClick={() => {
                setShowNewSectionEditor(true);
                onContentEdited(true);
              }}><FaPlus /> {t("NewSection.label")} </Button>
          </div>
        }
        {
          showNewSectionEditor &&
          <div>
            <div>
              <input type="text"
                id="newSectionInput"
                className="form-control"
                maxLength={100}
                ref={ref => inputRef.current['newSectionInput'] = ref} />
            </div>
            <div className='mt-2'>
              <Button
                variant='primary'
                className='me-2 px-3'
                onClick={() => {
                  onAddingNewSection(inputRef.current['newSectionInput'].value);
                  setShowNewSectionEditor(false);
                }}>
                {t("Save.label")}
              </Button>
              <Button
                variant='secondary'
                className='me-2'
                onClick={() => {
                  setShowNewSectionEditor(false);
                  onContentEdited(false);
                }}>
                {t("Cancel.label")}
              </Button>
            </div>
          </div>
        }
        {
          (itemToDelete?.section?.id > 0 || itemToDelete?.page?.id > 0) && (
            <ConfirmationModal
              title={t("confirmation.label")}
              modalShow={itemToDelete?.section?.id > 0 || itemToDelete?.page?.id > 0}
              messageText={t(itemToDelete.forSection ? "DeleteSection.label" : "DeletePage.label")}
              callbackModal={saveChangesConfirmationCallBack}>
              <div className='text-center'> {t(itemToDelete.forSection ? "DeleteSection.label" : "DeletePage.label")}</div>
            </ConfirmationModal>
          )

        }
      </div>
    </div >);
}

export default withTranslation()(ESRSReportingSidebar);


const PageDropSpacer = () => {
  return (
    <div className="pt-3 pb-3"
      style={{ backgroundColor: 'lightcyan' }}>
    </div>
  );
};
